import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '#app/components/ui/tooltip.tsx'
import { getPointOnDitch } from '#app/utils/farm-map.ts'

export type WaterMarkerProps = {
	ditch: number
	/** which gate/entry this marker belongs to; Ditch 9's segment depends on it */
	entry: string
	/** 0-1 progress along the ditch, from its gate to its final address */
	fraction: number
	label: string
	colorClassName?: string
}

/**
 * A marker that shows where the water currently is on a ditch. Position is
 * animated with a CSS transition, so re-renders with a new `fraction` (e.g.
 * from polling the loader) glide smoothly to the new spot along that ditch.
 * Callers should key this by `${entry}-${ditch}` so crossing over to a new
 * ditch snaps to its start instead of cutting diagonally across the map.
 */
export function WaterMarker({
	ditch,
	entry,
	fraction,
	label,
	colorClassName = 'fill-sky-500 stroke-sky-900',
}: WaterMarkerProps) {
	const { x, y } = getPointOnDitch(ditch, fraction, entry)

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<g
					className="transition-transform duration-300 ease-linear"
					style={{ transform: `translate(${x}px, ${y}px)` }}
				>
					<circle
						r={12}
						className={`${colorClassName} animate-pulse`}
						strokeWidth={3}
					/>
				</g>
			</TooltipTrigger>
			<TooltipContent>{label}</TooltipContent>
		</Tooltip>
	)
}
